import {Field, useField, useFormikContext} from "formik";
import {DatePicker} from "formik-mui-lab";
import React, {Fragment} from "react";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

const PickerField = ({...props}) => {
    const {setFieldValue} = useFormikContext();
    const [field] = useField(props);
    return(<Fragment>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Field
            {...field}
            {...props}
            component={DatePicker}
            autoOk
            selected={(field.value && new Date(field.value)) || null}
            onChange={val => {
                setFieldValue(field.name, val)
            }}
            />
        </LocalizationProvider>
    </Fragment>);
};
export const DatePickerField = ({...props}) => {
    return (<PickerField {...props} format={"yyyy-MM-dd"} placeholder={new Date().toISOString().slice(0,10)}/>);
};

export const YearPickerField = ({...props}) => {
 return(<PickerField {...props} format={"yyyy"} views={["year"]}/>);
};
